export const PROJECT_TASK_STATUS_ALL = 'all';
export const PROJECT_TASK_STATUS_ALL_COMPLETED = 'all_completed';
export const PROJECT_TASK_STATUS_ALL_INCOMPLETE = 'all_incomplete';
